import { createContext, useContext, ReactNode } from 'react'

const LangContext = createContext('uz-UZ')

export function LangProvider({ lang, children }: { lang: string, children: ReactNode }) {
    return <LangContext.Provider value={lang}>{children}</LangContext.Provider>
}

export const useLang = () => useContext(LangContext)